import api from "./apiService";


export const getUsers = (data) => api().post(`/admin/getUsers`, data).then(response => response); 

export const deleteUser = (id) => api().delete(`/admin/removeUser/${id}`).then(response => response); 

export const getUser = (id) => api().get(`/admin/getUser/${id}`).then(response => response); 

export const upateUserStatus = (id, data) => api().put(`/admin/updateUserStatus/${id}`, data).then(response => response); 

export const addUser = (data) => api().post(`/admin/addUser`, data).then(response => response);

export const updateUser = (id, data) => api().put(`/admin/updateUser/${id}`, data).then(response => response);

export const getDashboardData = () => api().get(`/admin/getDashboardData`).then(response => response); 

export const getUserExpertise = (id) => api().get(`/admin/getUserExpertise2/${id}`).then(response => response); 

export const getHallOfSages  = (data) => api().post(`/admin/hallofsages2`, data).then(response => response); 

const services = { getUsers, deleteUser, getUser, addUser, updateUser, getHallOfSages };

export default services;